import { useMemo } from 'react';
import debounce from 'react-utils/debounce';
const useDebounce = (func, delay) => {
  return useMemo(() => debounce(func, delay), [func, delay]);
};
export default useDebounce;